import React, { useState } from 'react';
import { Button, Flex, Modal } from 'antd';
import { FaRegEye, } from 'react-icons/fa';
import { Space, Table, Tag } from 'antd';
const ViewCaseDetails = ({item}) => {
    const columns = [
        {
          title: 'ID',
          dataIndex: 'id',
          key: 'id',
        },
        {
          title: 'Title',
          dataIndex: 'title',
          key: 'title',
        },
        {
          title: 'Case Number',
          dataIndex: 'case_number',
          key: 'case_number',
        },
        {
          title: 'Stage',
          dataIndex: 'stage',
          key: 'stage',
        },
        {
          title: 'Filing Date',
          dataIndex: 'filing_date',
          key: 'filing_date',
        },
        {
          title: 'Hearing Date',
          dataIndex: 'hearing_date',
          key: 'hearing_date',
        },
        {
          title: 'Starred',
          dataIndex: 'is_starred',
          key: 'is_starred',
          render: (is_starred) => (is_starred ? 'Yes' : 'No'),
        },
        {
          title: 'Archived',
          dataIndex: 'is_archived',
          key: 'is_archived',
          render: (is_archived) => (is_archived ? 'Yes' : 'No'),
        },
        {
          title: 'Created At',
          dataIndex: 'created_at',
          key: 'created_at',
        },
        {
          title: 'Updated At',
          dataIndex: 'updated_at',
          key: 'updated_at',
        },
        {
          title: 'Client',
          dataIndex: 'client',
          key: 'client',
        },
        {
          title: 'Category',
          dataIndex: 'category',
          key: 'category',
        },
        {
          title: 'Court',
          dataIndex: 'court',
          key: 'court',
        },
     
      ];
      const data = [
        {
          id: item.id,
          title: item.title,
          case_number: item.case_number,
          stage: item.stage,
          filing_date: item.filing_date,
          hearing_date: item.hearing_date,
          is_starred: item.is_starred,
          is_archived: item.is_archived,
          created_at: item.created_at,
          updated_at: item.updated_at,
          client: item.client,
          category: item.category,
          court: item.court,
        },
      ];
  const [open, setOpen] = useState(false);
  const [openResponsive, setOpenResponsive] = useState(false);
  return (
    <>
      <Button onClick={() => setOpenResponsive(true)} size='small' icon={<FaRegEye />} className='text-secondary'>
        View
      </Button>
      <Modal
        title='Modal responsive width'
        centered
        open={openResponsive}
        onOk={() => setOpenResponsive(false)}
        onCancel={() => setOpenResponsive(false)}
        width={{
          xs: '90%',
          sm: '80%',
          md: '70%',
          lg: '60%',
          xl: '50%',
          xxl: '40%',
        }}
      >
      <Table className='overflow-scroll ' columns={columns} dataSource={data} pagination={false} />
      </Modal>
    </>
  );
};
export default ViewCaseDetails;
